import React from 'react';

import { Translate } from '@change-corgi/core/react/i18n';
import { Icon } from '@change-corgi/design-system-legacy/components/icon';
import { iconOutlinedFlag } from '@change-corgi/design-system-legacy/icons';
import { Flex } from '@change-corgi/design-system-legacy/layout';
import { buttonResetStyles } from '@change-corgi/design-system-legacy/reset';
import { useIsSunriseTheme } from '@change-corgi/design-system-legacy/theme';
import { Text } from '@change-corgi/design-system-legacy/typography';

import { ReportAbuseLink } from 'src/app/shared/components/abuse';

import type { SupporterComment } from '../../shared/types';

import { useReportComment } from './hooks/useReportComment';

type ReportCommentProps = {
	comment: SupporterComment;
	petitionId: string;
	petitionSlug: string;
};
export const ReportComment: React.FC<ReportCommentProps> = ({ comment, petitionId, petitionSlug }) => {
	const {
		data: { canReportComment, a11yLabel },
		actions: { handleReportClick },
	} = useReportComment({ petitionId, comment });
	const isSunriseThemeEnabled = useIsSunriseTheme();

	if (!canReportComment) return null;

	return (
		<Flex onClick={handleReportClick}>
			<ReportAbuseLink
				type="supporter_comment"
				comment={{
					id: comment.id,
					likes: comment.likes,
					role: comment.role,
				}}
				petitionId={petitionId}
				petitionSlug={petitionSlug}
			>
				<button
					type="button"
					sx={buttonResetStyles}
					aria-label={a11yLabel}
					data-testid={`supporter-comment-${comment.id}-report-button`}
				>
					<Text
						sx={{
							color: isSunriseThemeEnabled ? 'sunrise.semantic.typography.strong' : 'typography-secondary',
							fontSize: '14px',
							display: 'flex',
							alignItems: 'center',
							gap: 8,
							...(isSunriseThemeEnabled && {
								fontSize: '14px',
							}),
						}}
					>
						<Icon
							icon={iconOutlinedFlag}
							sx={{
								...(isSunriseThemeEnabled
									? {
											fontSize: '18px',
										}
									: {
											fontSize: 'inherit',
										}),
							}}
						/>
						<Translate value="fe.components.comments.report" />
					</Text>
				</button>
			</ReportAbuseLink>
		</Flex>
	);
};
